var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-diamond"},_vm._l((_vm.diamonds),function(diamond,index){return _c('div',{key:diamond + index,staticClass:"diamond"},[_c('img',{attrs:{"src":require('../../images/' + diamond.type + '.png'),"alt":""}}),_vm._v(" "+_vm._s(diamond.num)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }